export default __webpack_public_path__ + "static/media/burundi.edc3607c.svg";